import { compose, defaultTo, filter, prop, sort, uniqBy } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { sortAlphabeticallyBy } from 'utils';

export const isOriginalUser = (userLogon) => (element) => {
	return element.userLogon.toUpperCase() === userLogon.toUpperCase();
};

export const swapOriginalUserFirstPosition = (userLogon) => (arr) => {
	const index = arr.findIndex(isOriginalUser(userLogon));
	if (index > -1) {
		const origElement = arr[index];
		arr.splice(index, 1);
		arr.splice(0, 0, origElement);
	}
};

export const filterActualUser = (userLogon) =>
	compose(
		uniqBy(prop('userLogon')),
		sort(sortAlphabeticallyBy('surname')),
		filter((t) => !(userLogon.toUpperCase() === t.userLogon.toUpperCase())),
		defaultTo([]),
	);

export const withoutActualUser = (delegations, appContext, representedUserLogin, allowedCompanies) => {
	const tokenUserLogon = appContext?.originalUserInfo?.userLogon;
	if (isNilOrEmpty(representedUserLogin)) {
		representedUserLogin = tokenUserLogon;
	}

	const originalUser = !isNilOrEmpty(allowedCompanies) ? [appContext?.originalUserInfo] : [];

	const delegation = [...originalUser, ...(delegations || [])];

	const withoutActualUser = filterActualUser(representedUserLogin)(delegation);
	swapOriginalUserFirstPosition(appContext?.originalUserInfo?.userLogon)(withoutActualUser);

	return withoutActualUser;
};
